/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const playlistPages = {
    MaestroPage: () => import('@/maestro/MaestroPage'),
    maestroService: () => import('@/maestro/maestroService'),
    personalizedPlaylistResolver: () => import('@/playlistdetail/personalizedPlaylistResolver'),
    PlaylistDetailPage: () => import('@/playlistdetail/PlaylistDetailPage'),
    PlaylistInvitePage: () => import('@/playlistdetail/PlaylistInvitePage'),
}
